export default __webpack_public_path__ + "static/Theinhardt-Medium-Italic-subset-58d34744a0d6ecd4f453f9f7e177c4a6.woff";